import React, { useEffect } from 'react';
import { ClipboardCheck } from 'lucide-react';
import CloseButton from './ui/CloseButton';

const PURPLE_GRADIENT = 'linear-gradient(145deg,#7c3aed,#5b21b6)';
const badge = (bg, color) => ({ background: bg, color, fontSize: '0.8rem', padding: '0.4rem 0.6rem', borderRadius: '0.4rem' });

// Shows the outcome of a "Generate Micro Quiz" run (created / already-existing / failed).
const MicroQuizReportModal = ({ report, onClose }) => {
    // Lock background scroll while the modal is open.
    useEffect(() => {
        const prev = document.body.style.overflow;
        document.body.style.overflow = 'hidden';
        return () => { document.body.style.overflow = prev; };
    }, []);

    if (!report) return null;

    return (
        <div style={{
            position: 'fixed', inset: 0, backgroundColor: 'rgba(0,0,0,0.5)',
            display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1100, padding: '1rem',
        }}>
            <div style={{
                backgroundColor: '#ffffff', borderRadius: '0.9rem',
                boxShadow: '0 10px 25px -5px rgba(0,0,0,0.3)', width: '90%', maxWidth: 'min(680px, 96vw)',
                maxHeight: '90vh', display: 'flex', flexDirection: 'column', overflow: 'hidden',
            }}>
                {/* Header */}
                <div style={{ background: PURPLE_GRADIENT, color: '#fff', padding: '1.1rem 1.25rem', position: 'relative', flexShrink: 0 }}>
                    <CloseButton onClick={onClose} />
                    <h2 style={{ fontSize: '1.3rem', fontWeight: 700, margin: 0, display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                        <ClipboardCheck style={{ width: '1.25rem', height: '1.25rem' }} /> Micro Test Report
                    </h2>
                </div>

                {/* Body (scrolls) */}
                <div style={{ flex: 1, overflowY: 'auto', padding: '1rem 1.25rem' }}>
                    <div className="d-flex flex-wrap gap-2 mb-3">
                        <span style={badge('#dcfce7', '#166534')}>Created: {report.created.length}</span>
                        <span style={badge('#fef3c7', '#92400e')}>Already existing: {report.skipped_existing.length}</span>
                        <span style={badge('#fee2e2', '#991b1b')}>Failed: {report.failed.length}</span>
                    </div>

                    {report.created.length > 0 && (
                        <div className="mb-2">
                            <div className="fw-semibold text-success small mb-1">Newly created (unpublished)</div>
                            <ul className="mb-0 small">
                                {report.created.map(r => (
                                    <li key={r.quiz_id}>{r.title} <span className="text-muted">(#{r.quiz_id}, from {r.source_title})</span></li>
                                ))}
                            </ul>
                        </div>
                    )}
                    {report.skipped_existing.length > 0 && (
                        <div className="mb-2">
                            <div className="fw-semibold small mb-1" style={{ color: '#92400e' }}>Already existing (skipped)</div>
                            <ul className="mb-0 small">
                                {report.skipped_existing.map(r => (
                                    <li key={r.quiz_id}>{r.title} <span className="text-muted">(#{r.quiz_id}, {r.is_published ? 'published' : 'unpublished'}, from {r.source_title})</span></li>
                                ))}
                            </ul>
                        </div>
                    )}
                    {report.failed.length > 0 && (
                        <div className="mb-2">
                            <div className="fw-semibold small mb-1" style={{ color: '#991b1b' }}>Failed</div>
                            <ul className="mb-0 small">
                                {report.failed.map((r, i) => (
                                    <li key={i}>{r.source_title} — {r.section}: <span className="text-muted">{r.reason}</span></li>
                                ))}
                            </ul>
                        </div>
                    )}
                </div>

                {/* Footer */}
                <div style={{ borderTop: '1px solid #e5e7eb', padding: '0.85rem 1.25rem', display: 'flex', justifyContent: 'flex-end', flexShrink: 0 }}>
                    <button className="btn btn-primary" onClick={onClose}>Done</button>
                </div>
            </div>
        </div>
    );
};

export default MicroQuizReportModal;
